<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div class="main-container"
  [ngClass]="{'blue': blue }">
  <!-- ============================================================== -->
  <!-- Topbar - style you can find in header.scss -->
  <!-- ============================================================== -->
  <mat-toolbar color="primary"
    class="topbar telative">
    <!-- ============================================================== -->
    <!-- Logo - style you can find in header.scss -->
    <!-- ============================================================== -->
    <div class="navbar-header"
      [ngClass]="{'d-none d-sm-flex': timeLeft > 0}">
      <a class="navbar-brand"
        href="index.html">
        <!-- Logo icon -->
        <b>
          <!--You can put here icon as well // <i class="wi wi-sunset"></i> //-->
          <!-- Dark Logo icon -->
          <img src="assets/images/odq-logo-Icon-small.png"
            alt="homepage"
            class="light-logo">
            <!-- Light Logo icon -->
            <!-- <img src="assets/images/logo-light-icon.png" alt="homepage" class="light-logo"> -->
          </b>
          <!--End Logo icon -->
          <!-- Logo text -->
          <span class="d-none d-sm-flex"
            [ngClass]="{'d-sm-none d-md-flex': timeLeft > 0}">
            <!-- dark Logo text -->
            <!-- Light Logo text -->
            <img src="assets/images/odq-logo-text-small.png"
              class="light-logo"
              alt="homepage">
            </span>
          </a>
        </div>
        <!-- ============================================================== -->
        <!-- sidebar toggle -->
        <!-- ============================================================== -->
        <div class="menuAndVersion">
          <button mat-icon-button
            [ngClass]="{'d-none d-md-flex': timeLeft > 0}"
            (click)="snav.toggle()"
            value="sidebarclosed">
            <mat-icon>menu</mat-icon>
          </button>
          @if (currentVersion && currentVersion!='@@Version') {
            <span class="versionLabel">
              V{{currentVersion}}
            </span>
          }
        </div>
        <span style="flex: 1 1 0%"></span>
        <!-- ============================================================== -->
        <!-- app header component - style you can find in header.scss / header.component.ts-->
        <!-- ============================================================== -->
        <odq-header (loggedIn)="login()"
          (loggedOut)="logout()"
          (passwordReset)="resetPassword()"
          [isAuthorized]="isAuthorized"
          [user]="user"
          [userLoading]="authLoading$ | async"
          [sidebarInfoVisible]="sidebarInfoVisible"
          (languageChanged)="useLanguage($event)"
          [tokenExpiringIn]="timeLeft">
        </odq-header>
      </mat-toolbar>


      @if (latestVersion!=null && latestVersion!=currentVersion) {
        <div class="newVersionLabel">
          {{ 'version.labelBeforeAnchor' | translate: { latestVersion: latestVersion } }}
          <a class="newVersionAnchor" href="JavaScript: location.reload(true);">{{ 'version.labelAnchor' | translate}}</a>
          {{ 'version.labelAfterAnchor' | translate}}
        </div>
      }

      <!-- ============================================================== -->
      <!-- End Topbar - style you can find in pages.scss -->
      <!-- ============================================================== -->
      <mat-sidenav-container class="platine-sidenav-container"
        [style.marginTop.px]="mobileQuery.matches ? 0 : 0"
        [ngClass]="{'minisidebar': minisidebar}">
        <!-- ============================================================== -->
        <!-- Sidebar - style you can find in sidebar.scss -->
        <!-- ============================================================== -->
        <mat-sidenav #snav
          id="snav"
          class="pl-xs"
          [mode]="isOldBrowser || mobileQuery.matches ? 'side' : 'over'"
          fixedTopGap="0"
          [opened]="mobileQuery.matches"
          [disableClose]="mobileQuery.matches"
          (open)="sidebarOpened = true"
          (close)="sidebarOpened = false">
          <app-sidebar (itemclicked)="onItemClick()"></app-sidebar>
        </mat-sidenav>
        <!-- ============================================================== -->
        <!-- Sidebar - style you can find in sidebar.scss -->
        <!-- ============================================================== -->

        <!-- ============================================================== -->
        <!-- Page container - style you can find in pages.scss -->
        <!-- ============================================================== -->
        <mat-sidenav-content class="page-wrapper d-flex flex-column">
          <div [ngClass]="{ 'col-9': isSidebarInfoVisible(), 'col-12': !isSidebarInfoVisible() }" style="flex: 1 0 auto">
            <router-outlet>
              <app-spinner></app-spinner>
            </router-outlet>
          </div>
          <div style="flex: 0 0 auto"></div>
          <app-footer class="mt-2 mx-2 mb-sm-1"></app-footer>
        </mat-sidenav-content>
        <!-- ============================================================== -->
        <!-- Page container - style you can find in pages.scss -->
        <!-- ============================================================== -->
      </mat-sidenav-container>

    </div>

    <ng-template #loader>
      <div class="spinner-container">
        <mat-spinner></mat-spinner>
        <span>Authorizing in progress...</span>
      </div>
    </ng-template>

    <ng-template #badBrowser>
      <div class="blue page-wrapper">
        <div class="page-content"
          style="color: white; font-size: 2rem; text-align: center;">
          <img src="../../../../assets/images/odq-logo-Icon-small.png" />
          <span style="margin-left: 10px">Ne pas utiliser ce browser</span>
        </div>
      </div>
    </ng-template>

    @if ((processingInscription$ | async) || (processingFARPSubscription$ | async) || (processingCompanySubscription$ | async)) {
      <div class="spinner-container-fullpage"
        >
        <div class="pleaseWaitContainer">
          <span>{{'shoppingCart.pleaseWaitPayment' | translate}}</span>
          <mat-spinner [diameter]="40"></mat-spinner>
        </div>
      </div>
    }
